import SharePage from './pages/SharePage';
import { DiscountLink } from '@/components/shop/DiscountLink';
import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import '@/App.css';
import '@/styles/product-images.css';
import '@/styles/legal.css';
import '@/styles/admin-mobile.css';
import { Header, Footer } from '@/components/site/Layout';
import { LaunchNotice } from '@/components/site/LaunchNotice';
import { Hero } from '@/components/site/Hero';
import { Services } from '@/components/site/Services';
import { Process, ContactBanner } from '@/components/site/Sections';
import { InquiryDialog } from '@/components/site/InquiryDialog';
import { ContentDialog } from '@/components/site/ContentDialog';
import LegalPage from '@/pages/LegalPage';
import { legalDocuments } from '@/data/legal';
import { legalNavigation } from '@/data/legal/company';
import { StudioLayout } from '@/components/studio/StudioLayout';
import DesignerPage from '@/designer/DesignerPage';
import StudioCartPage from '@/pages/StudioCartPage';
import StudioCheckoutPage from '@/pages/StudioCheckoutPage';
import AccountPage from './pages/AccountPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import StudioOrderPage from '@/pages/StudioOrderPage';
import AdminProductsPage from '@/pages/AdminProductsPage';
import { LandingPage, PlatformHome } from '@/pages/PlatformPages';
import InspirationPage from '@/pages/InspirationPage';
import ProductDetailPage from '@/pages/ProductDetailPage';
import GroupCreatePage from '@/pages/GroupCreatePage';
import GroupManagePage from '@/pages/GroupManagePage';
import GroupJoinPage from '@/pages/GroupJoinPage';

function HomePage() {
  const [inquiry, setInquiry] = useState(null);
  const [content, setContent] = useState(null);
  const request = (material = 'offen') => { setContent(null); setInquiry(material); };
  return (
    <>
      <a className="skip-link" href="#leistungen" data-testid="skip-to-content">Zum Inhalt</a>
      <Header onRequest={() => request()} onContent={setContent} />
      <main>
        <Hero onRequest={() => request()} onExamples={() => setContent({ type: 'examples' })} />
        <Services onSelect={service => setContent({ type: 'service', service })} />
        <Process />
        <ContactBanner onRequest={() => request()} />
      </main>
      <Footer onContent={setContent} />
      <ContentDialog content={content} onClose={() => setContent(null)} onRequest={request} onSelect={service => setContent(service ? { type: 'service', service } : { type: 'examples' })} />
      <InquiryDialog material={inquiry} onClose={() => setInquiry(null)} />
    </>
  );
}

function RouteScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    const target = window.location.hash.slice(1);
    const id = requestAnimationFrame(() => {
      if (target && document.getElementById(target)) document.getElementById(target).scrollIntoView();
      else window.scrollTo({ top: 0, behavior: 'instant' });
    });
    return () => cancelAnimationFrame(id);
  }, [pathname]);
  return null;
}

export default function App() {
  return <BrowserRouter><RouteScroll /><DiscountLink /><LaunchNotice /><Routes><Route path="/" element={<PlatformHome />} /><Route path="/inspiration" element={<InspirationPage />} />{['/verwaltung','/verwaltung/artikel-ki','/verwaltung/dekorationen','/verwaltung/motive','/verwaltung/ki','/verwaltung/ki-grafiken','/verwaltung/archiv','/verwaltung/3d-tiefe','/verwaltung/anlaesse','/verwaltung/startseite','/verwaltung/anfragen','/verwaltung/bestellungen','/verwaltung/rabattcodes','/verwaltung/bestellungen/:orderId','/verwaltung/einstellungen','/verwaltung/artikel/:productId','/verwaltung/artikel/:productId/vorlagen/:templateId'].map(path=><Route key={path} path={path} element={<AdminProductsPage/>}/>)}{legalNavigation.map(item => <Route key={item.key} path={item.path} element={<LegalPage document={legalDocuments[item.key]} />} />)}<Route element={<StudioLayout />}><Route path="/gestalten" element={<DesignerPage />} /><Route path="/schnellstart" element={<Navigate to="/gestalten" replace />} /><Route path="/teilen/:id" element={<SharePage />} /><Route path="/warenkorb" element={<StudioCartPage />} /><Route path="/gruppe/neu" element={<GroupCreatePage />} /><Route path="/gruppe/verwalten/:token" element={<GroupManagePage />} /><Route path="/mitmachen/:code" element={<GroupJoinPage />} /><Route path="/kasse" element={<StudioCheckoutPage />} /><Route path="/testabschluss" element={<StudioCheckoutPage />} /><Route path="/bestellung/:id" element={<StudioOrderPage />} /><Route path="/konto" element={<AccountPage />} /><Route path="/konto/passwort-neu" element={<ResetPasswordPage />} /><Route path="/testbestellung/:id" element={<StudioOrderPage />} /></Route><Route path="/produkt/:slug" element={<ProductDetailPage />} /><Route path="/:slug" element={<LandingPage />} /><Route path="*" element={<PlatformHome />} /></Routes></BrowserRouter>;
}